<template>
   <div>
      <vx-card>
        <vs-row vs-w="12" vs-type="flex" vs-justify="left">
          <vs-button size="medium" color="warning" icon="edit" class="ml-3" @click="$router.push({name: 'worklist-klinik'});">Kembali</vs-button>
        </vs-row>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          :filename="(dataPatient?(dataPatient.visitNumber+'_'+dataPatient.patient.name):'Hasil Pemeriksaan LABORATORIUM')"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"

          @progress="onProgress($event)"
          @startPagination="onStartPagination()"
          @hasPaginated="onHasPaginated()"
          @beforeDownload="onBeforeDownload($event)"
          @hasDownloaded="onHasDownloaded($event)"
          ref="html2Pdf">
          <section slot="pdf-content" class="pdf-content">
            <section class="report-info">
              <h5 class="title">HASIL PEMERIKSAAN LABORATORIUM</h5>
              <section class="patient-info">
                <table>
                  <tr>
                    <td class="txt">&nbsp;</td>
                    <td colspan="3" style="text-align: right">
                      <label style="font-size=10px"><b>Dokter Penanggung Jawab : {{kaLab}}</b></label>
                    </td>
                  </tr>
                  <tr>
                    <td class="txt">Nama</td>
                    <td class="val">: {{dataPatient.patient?dataPatient.patient.name:''}}</td>
                    <td class="txt">No. Laboratorium</td>
                    <td class="val">: {{dataPatient?dataPatient.visitNumber:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">No. RM/NIK</td>
                    <td class="val">: {{dataPatient.patient?dataPatient.patient.patientNumber:''}}</td>
                    <td class="txt">Dokter Pengirim</td>
                    <td class="val">: {{dataPatient.physician?dataPatient.physician.name:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">Tanggal Lahir/Umur</td>
                    <td class="val">: {{dataPatient.patient.dob | formatDate}} / {{dataPatient.patient.dob | calcAge}} TH</td>
                    <td class="txt">Tipe Kunjungan</td>
                    <td class="val">: {{dataPatient.patientType?dataPatient.patientType.name:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">Jenis Kelamin</td>
                    <td class="val">: {{dataPatient.patient.gender?dataPatient.patient.gender.name:''}}</td>
                    <td class="txt">Ruangan</td>
                    <td class="val">: {{dataPatient.ward?dataPatient.ward.name:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">Alamat</td>
                    <td class="val">: {{dataPatient.patient?dataPatient.patient.address:''}}</td>
                    <td class="txt">No. Telp</td>
                    <td class="val">: {{dataPatient.patient?dataPatient.patient.phoneNumber:''}}</td>
                  </tr>
                </table>
              </section>

              <hr style="margin-top: 20px;"/>
              <div>
                <label style="margin-left:100px"><b>JENIS PEMERIKSAAN</b></label>
                <label style="margin-left:190px"><b>HASIL</b></label>
                <label style="margin-left:75px"><b>UNIT</b></label>
                <label style="margin-left:55px"><b>NILAI RUJUKAN</b></label>
              </div>
              <hr/>

              <section class="test-result">
                <table style="width: 100%">
                    <tbody :key="indextr" v-for="(tr, indextr) in listTest">
                        <vs-tr :data="tr">
                            <vs-td class="val1">{{tr.name}}</vs-td>
                            <vs-td class="val2">&nbsp;</vs-td>
                            <vs-td class="val3">&nbsp;</vs-td>
                            <vs-td class="val2">&nbsp;</vs-td>
                        </vs-tr>
                        <vs-tr :key="indextr1" v-for="(tr1, indextr1) in tr.test" :style="(tr1.outNormal?'color: red;':'')" v-if="tr1.checked">
                            <vs-td class="val4">o {{tr1.name + (tr1.outNormal?' *':'')}}</vs-td>
                            <vs-td class="val2">{{tr1.result}}</vs-td>
                            <vs-td class="val3">{{tr1.unit}}</vs-td>
                            <vs-td class="val2">{{tr1.measureRanges}}</vs-td>
                        </vs-tr>
                        <vs-tr :key="'a_'+indextr2" v-for="(tr2, indextr2) in tr.chidlGroup">
                            <vs-td class="val4">o {{tr2.name}}</vs-td>
                            <vs-td class="val2">&nbsp;</vs-td>
                            <vs-td class="val3">&nbsp;</vs-td>
                            <vs-td class="val2">&nbsp;</vs-td>
                        </vs-tr>
                        <vs-tr :key="'b_'+indextr3" v-for="(tr3, indextr3) in (tr.chidlGroup!==null?tr.chidlGroup[0].test:[])" :style="(tr3.outNormal?'color: red;':'')" v-if="tr3.checked">
                            <vs-td class="val5">- {{tr3.name + (tr3.outNormal?' *':'')}}</vs-td>
                            <vs-td class="val2">{{tr3.result}}</vs-td>
                            <vs-td class="val3">{{tr3.unit}}</vs-td>
                            <vs-td class="val2">{{tr3.measureRanges}}</vs-td>
                        </vs-tr>
                    </tbody>
                </table>
              </section>
              <section class="footer">
                <div style="margin-top: 10px">
                  <label>Keterangan :</label>
                  <label style="margin-left: 10px; color: red">* </label>
                  <label style="margin-left: 5px;">Abnormal</label>
                  <label style="margin-left: 10px; color: red">*** </label>
                  <label style="margin-left: 5px;">Nilai Kritis</label>
                </div>
                <table style="width: 800px; margin-top: 20px">
                  <tr>
                    <td class="txt">Tgl Pengambilan Sampel</td>
                    <td class="val">: {{dataPatient.createdAt | formatDate}}</td>
                    <td class="txt1">Diperiksa oleh</td>
                    <td class="val1">: {{dataPatient.testedBy?dataPatient.testedBy.name:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">Waktu Pemeriksaan</td>
                    <td class="val">: {{dataPatient.timeStarted | formatDateTime}}</td>
                    <td class="txt1">Diverifikasi oleh</td>
                    <td class="val1">: {{dataPatient.verifiedBy?dataPatient.verifiedBy.name:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">Waktu Selesai</td>
                    <td class="val">: {{dataPatient.timeVerified2 | formatDateTime}}</td>
                    <td class="txt1">Divalidasi Teknis oleh</td>
                    <td class="val1">: {{dataPatient.verified2By?dataPatient.verified2By.name:''}}</td>
                  </tr>
                </table>
                <div style="display: flex">
                  <table style="width: 400px; margin-top: 20px">
                    <tr>
                      <td class="txt">Catatan :</td>
                    </tr>
                    <tr>
                      <td class="txt">{{(dataPatient.visitNote.length > 0 && dataPatient.visitNote[0].noteType==='VALIDATE')?dataPatient.visitNote[0].note:''}}</td>
                    </tr>
                  </table>
                  <div style="width: 400px; display: inline-grid">
                    <label style="margin-top: 50px">Penanggung Jawab Laboratorium</label>
                    <label style="margin-left: 10px; margin-top: 80px">{{kaLab}}</label>
                    <label style="margin-left: 5px;">{{nip}}</label>
                  </div>
                </div>
              </section>
            </section>
          </section>
        </vue-html2pdf>
      </vx-card>
   </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import initialConfig from '@/../initialConfig.js';

export default {
    components: {
        VueHtml2pdf
    },
    data() {
      return {
        dataPatient: {},
        progress: 0,
        generatingPdf: false,
        pdfOption: {
          margin: [0, 0, 10, 10],
        },
        kaLab: (initialConfig?initialConfig.kaLab:''),
        nip: (initialConfig?initialConfig.nip:''),
        pdfDownloaded: false,
        html2PdfX: null,
        optionX: {},
        pdfContentX: null,
        listTest: []
      };
    },
    methods: {
      onProgress(progress) {
        this.progress = progress;
        console.log(`PDF generation progress: ${progress}%`);
      },
      onStartPagination(e) {
        console.log(`PDF has started pagination :`+e);
      },
      onHasPaginated(e) {
        console.log(`PDF has paginated :`+e);
      },
      async onBeforeDownload ({ html2pdf, options, pdfContent }) {
        console.log(`PDF onBeforeDownload`);
        /*  this.html2PdfX = html2pdf;
        this.optionX = options;
        this.pdfContentX = pdfContent;

          await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
              const totalPages = pdf.internal.getNumberOfPages()
              for (let i = 1; i <= totalPages; i++) {
                  pdf.setPage(i)
                  pdf.setFontSize(10)
                  pdf.setTextColor(150)
                  pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
              }
          }).save()*/
      },
      onHasDownloaded(blobPdf) {
        this.pdfDownloaded = true;
        console.log(`PDF has downloaded yehey`);
        console.log(blobPdf);
      },
      generatePdf() {
        this.$refs.html2Pdf.generatePdf();
      }
    },
    mounted() {
      this.generatePdf();
    },
    created() {
      this.dataPatient = this.$route.params.dataPatient;
      if (!this.dataPatient) {
        this.$vs.notify({
          title: "Info",
          time: 3000,
          text: "Session habis silahkan cetak ulang dari worklist",
          color: "warning",
          position: "top-right"
        });

        this.$router.push({name: 'worklist-klinik'});
      }
      this.listTest = this.$route.params.listTest;
    }
}
</script>

<style lang="scss" scoped>
  .pdf-content {
    width: 800px;
    padding-top: 76px;

    /* Full height */
    height: 100%;

    /* Center and scale the image nicely */
    background-repeat: no-repeat;
    background-size: cover;
    .title {
      text-align: center;
      margin-top: 10px;
    }
    .title1 {
      text-align: right;
      margin-top: 10px;
      font-weight: bold;
    }
    label {
      font-size: 10px;
    }
    .report-info {
      padding:85px 50px 0px 50px;
      .patient-info {
        margin-top: 20px;
        font-size: 10px;
      }
      .patient-info td {
          padding: 0 10px 0 10px;
      }
      .patient-info td.txt {
          width: 150px;
      }
      .patient-info td.val {
          width: 220px;
      }
      .test-result td {
        padding: 0 7px 0 7px;
        text-align: center;
        //border-bottom: 1px dotted black;
        font-size: 10px !important;
      }
      .test-result td.val1 {
        width: 45%;
        font-weight: bold;
        text-align: left !important;
        padding-left: 25px !important;
      }
      .test-result td.val2 {
        width: 20%;
      }
      .test-result td.val3 {
        width: 10%;
      }
      .test-result td.val4 {
        width: 50%;
        text-align: left !important;
        padding-left: 35px !important;
      }
      .test-result td.val5 {
        text-align: left !important;
        padding-left: 50px !important;
      }
      .test-result td.val6 {
        width: 50%;
        text-align: left !important;
        padding-left: 70px !important;
      }
      .footer {
          font-size: 10px;
      }
      .footer td.txt {
          width: 80px;
      }
      .footer td.txt1 {
          width: 60px;
      }
      .footer td.val {
          width: 90px;
      }
      .footer td.val1 {
          width: 150px;
      }
      .user-details {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        .user-name {
          margin-bottom: 10px;
          margin-top: 30px;
          flex-shrink: 0;
        }
        .detail-container {
          font-size: 13px;
          flex-shrink: 0;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
          .detail-label {
            font-weight: 600;
            margin-right: 5px;
            font-size: 13px;
          }
        }
      }
      .request-details {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        .user-name {
          margin-bottom: 10px;
          flex-shrink: 0;
        }
        .detail-container {
          font-size: 13px;
          flex-shrink: 0;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
          .detail-label {
            font-weight: 600;
            margin-right: 5px;
            font-size: 13px;
          }
        }
      }
    }
  }
</style>
